<template>
	<form>
		<b-field label="Nombre de usuario" >
            <b-input  icon="shield-account" type="text" placeholder="Ej. paco" v-model="datosUsuario.usuario"></b-input>
        </b-field>
        <b-field label="Nombre completo " >
            <b-input  icon="account" type="text" placeholder="Ej. Francisco Perez Tezcatlipoca" v-model="datosUsuario.nombre"></b-input>
        </b-field>
        <b-field label="Teléfono del usuario" >
            <b-input step="any" icon="phone" type="number" placeholder="Ej. 2311459874" v-model="datosUsuario.telefono"></b-input>
        </b-field>

		<b-field label="Rol">
			<b-select v-model="datosUsuario.roleId" placeholder="Selecciona un rol">
				<option :value="null">-- Ninguno --</option>
				<option v-for="r in roles" :key="r.id" :value="r.id">{{ r.nombre }}</option>
			</b-select>
		</b-field>

		<b-field label="Grupo">
			<b-select v-model="datosUsuario.grupoId" placeholder="Selecciona un grupo">
				<option :value="null">-- Ninguno --</option>
				<option v-for="g in grupos" :key="g.id" :value="g.id">{{ g.nombre }} - {{ g.jefe }}</option>
			</b-select>
		</b-field>

         <div class="buttons has-text-centered">
            <b-button type="is-primary" size="is-large" icon-left="check" @click.prevent="registrar">Registrar</b-button>
            <b-button type="is-dark" size="is-large" icon-left="cancel" tag="router-link" to="/usuarios">Cancelar</b-button>
        </div>
        <errores-component :errores="mensajesError" v-if="mensajesError.length > 0" />
	</form>
</template>
<script>
	import Utiles from '../../Servicios/Utiles'
	import ErroresComponent from '../Extras/ErroresComponent'
	import HttpService from '../../Servicios/HttpService'

	export default {
		name: "FormUsuario",
		props: ["usuario"],
		components: { ErroresComponent },

		data: function(){
			return {
				datosUsuario: {
					usuario: "",
					nombre: "",
					telefono: "",
					roleId: null,
					grupoId: null
				},
				roles: [],
				grupos: [],
				mensajesError: []
			}
		},

		mounted: function(){
			if(this.usuario) {
				this.datosUsuario = Object.assign({}, this.datosUsuario, this.usuario)
				if(this.datosUsuario.roleId !== null && this.datosUsuario.roleId !== undefined) this.datosUsuario.roleId = Number(this.datosUsuario.roleId)
				if(this.datosUsuario.grupoId !== null && this.datosUsuario.grupoId !== undefined) this.datosUsuario.grupoId = Number(this.datosUsuario.grupoId)
			}
			this.cargarRoles()
			this.cargarGrupos()
		},

		watch: {
			usuario: {
				handler: function(newVal){
					if (!newVal) return
					this.datosUsuario = Object.assign({}, this.datosUsuario, newVal)
					if(this.datosUsuario.roleId !== null && this.datosUsuario.roleId !== undefined) this.datosUsuario.roleId = Number(this.datosUsuario.roleId)
					if(this.datosUsuario.grupoId !== null && this.datosUsuario.grupoId !== undefined) this.datosUsuario.grupoId = Number(this.datosUsuario.grupoId)
					this.ensureSelection()
				},
				deep: true
			},
			roles: function(){ this.ensureSelection() },
			grupos: function(){ this.ensureSelection() }
		},

		created: function(){
			console.log('FormUsuario.created - initial usuario:', this.usuario)
		},

		methods: {
			cargarRoles: async function(){
				try{
					const payload = { accion: 'obtener' }
					const roles = await HttpService.obtenerConConsultas('roles.php', payload)
					this.roles = (roles || []).map(function(r){ return Object.assign({}, r, { id: Number(r.id) }) })
					this.ensureSelection()
				} catch(e){
					this.roles = []
				}
			},

			cargarGrupos: async function(){
				try{
					const payload = { accion: 'obtener' }
					const grupos = await HttpService.obtenerConConsultas('grupos.php', payload)
					this.grupos = (grupos || []).map(function(g){ return Object.assign({}, g, { id: Number(g.id) }) })
					this.ensureSelection()
				} catch(e){
					this.grupos = []
				}
			},

			ensureSelection: function(){
				if (this.datosUsuario) {
					if(this.datosUsuario.roleId !== null && this.datosUsuario.roleId !== undefined) this.datosUsuario.roleId = Number(this.datosUsuario.roleId)
					if(this.datosUsuario.grupoId !== null && this.datosUsuario.grupoId !== undefined) this.datosUsuario.grupoId = Number(this.datosUsuario.grupoId)
					if(this.datosUsuario.roleId != null && this.roles && !this.roles.find(function(r){ return Number(r.id) === Number(this.datosUsuario.roleId) }.bind(this))) this.datosUsuario.roleId = null
					if(this.datosUsuario.grupoId != null && this.grupos && !this.grupos.find(function(g){ return Number(g.id) === Number(this.datosUsuario.grupoId) }.bind(this))) this.datosUsuario.grupoId = null
					console.log('FormUsuario.ensureSelection', { roleId: this.datosUsuario.roleId, roles: this.roles.map(function(r){ return r.id }), grupoId: this.datosUsuario.grupoId, grupos: this.grupos.map(function(g){ return g.id }) })
				}
			},

			registrar: function(){
				this.mensajesError = Utiles.validarDatos(this.datosUsuario)
				if(this.mensajesError.length > 0) return
				this.$emit("registrar", this.datosUsuario)
				this.datosUsuario  = {
					usuario: "",
					nombre: "",
					telefono: "",
					roleId: null,
					grupoId: null
				}
			}
		}
	}
</script>
